import gql from 'graphql-tag';

export const CALCULATE_FINANCE_PAYMENTS = gql`
  query CalculateFinancePayments($input: [CalculateMultiplePaymentsInput]) {
    calculateMultiplePayments(input: $input) {
      paymentOptions {
        paymentAmountPerPeriod
        dealerMarkup
        financeProfit
        paymentAmountPerPeriodWithoutDealerMarkup
        amountDueToday
        overages
        rate
        term
        customerRate
        isSubsidized
        subsidyCapConfiguration {
          subsidyCapType
          lenderName
          maxSubsidyAmount
          netInvoicePercentage
          netInvoiceAmount
        }
        costOfDeferredPayments
        term
      }
    }
  }
`;
